import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import "../../../src/Header.css";

const Header = () => {

  const [isSticky, setIsSticky] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [events, setEvents] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [showResults, setShowResults] = useState(false);

  const navigate = useNavigate();

  // Sticky header
  useEffect(() => {
    const onScroll = () => setIsSticky(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Fetch events
  useEffect(() => {
    axios
      .get("https://ezer-eventapp.onrender.com/events")
      .then(res => setEvents(res.data))
      .catch(err => console.log(err));
  }, []);

  // Prevent body scroll when mobile menu open
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "auto";
  }, [mobileOpen]);

  // Search input
  const handleInputChange = (value) => {

    setSearchTerm(value);

    if (value.trim() === "") {
      setFilteredResults([]);
      setShowResults(false);
      return;
    }

    const results = events.filter(event =>
      event.name?.toLowerCase().includes(value.toLowerCase()) ||
      event.categories?.some(cat =>
        cat.toLowerCase().includes(value.toLowerCase())
      ) ||
      event.description?.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredResults(results.slice(0, 6));
    setShowResults(true);
  };

  const handleSearch = () => {

    const query = searchTerm.trim();

    if (query !== "") {
      navigate(`/search?q=${encodeURIComponent(query)}`);
      setShowResults(false);
      setMobileOpen(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSearch();
  };

  return (
    <>
      <header className={`site-header ${isSticky ? "sticky" : ""}`}>
        <div className="header-container">

          {/* LOGO */}

          <NavLink
            to="/"
            className="logo"
            onClick={() => setMobileOpen(false)}
          >
            Ezer<span className="logo-accent">Booking</span>
          </NavLink>
          <div></div>

          {/* SEARCH */}

          <div className="search-wrapper">

            <div className="search-bar">

              <input
                type="text"
                placeholder="Find services..."
                value={searchTerm}
                onChange={(e) => handleInputChange(e.target.value)}
                onKeyDown={handleKeyDown}
              />

              <button
                className="search-btn-go"
                onClick={handleSearch}
              >
                🔍
              </button>

              {showResults && filteredResults.length > 0 && (

                <div className="search-dropdown">

                  {filteredResults.map(item => (

                    <div
                      key={item._id}
                      className="search-item"
                      onClick={() => {
                        navigate(`/search?q=${encodeURIComponent(item.name)}`);
                        setSearchTerm("");
                        setShowResults(false);
                      }}
                    >

                      <img
                        src={item.images?.[0]}
                        alt=""
                      />

                      <div className="search-info">

                        <div className="search-title">
                          {item.name}
                        </div>

                        <small>
                          {item.categories?.join(", ")}
                        </small>

                      </div>

                    </div>

                  ))}

                </div>

              )}

            </div>

          </div>

          {/* DESKTOP NAV */}

          <nav className="desktop-nav">

            <NavLink to="/" className={({ isActive }) => (isActive ? "active-link" : "")}>
              Home
            </NavLink>

            <NavLink to="/FlashDeals" className={({ isActive }) => (isActive ? "active-link" : "")}>
              Services
            </NavLink>

            <NavLink to="/contact" className={({ isActive }) => (isActive ? "active-link" : "")}>
              Contact
            </NavLink>

          </nav>

          {/* MENU BUTTON */}

          <button
            className={`menu-toggle ${mobileOpen ? "open" : ""}`}
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

        </div>
      </header>

      {/* MOBILE MENU */}

     <div className={`mobile-menu-overlay ${mobileOpen ? "open" : ""}`}>
  <div className="mobile-menu-container">

    <nav className="mobile-links">

      <NavLink to="/" onClick={() => setMobileOpen(false)}>
        Home
      </NavLink>

      <NavLink to="/FlashDeals" onClick={() => setMobileOpen(false)}>
        Services
      </NavLink>

      <NavLink to="/contact" onClick={() => setMobileOpen(false)}>
        Contact
      </NavLink>

      {/* 🔥 BOOK NOW BUTTON */}
      <button className="mobile-book-btn">
        Book Now
      </button>

    </nav>

  </div>
</div>
    </>
  );
};

export default Header;